import React, { useEffect, useState } from 'react'
import { Footer } from '@/components/Footer'
import { Header } from '@/components/Header'
import { useAppSelector } from '@/hooks'
import { AuthorCard } from '@/components/AuthorCard'
import { PaintingCard } from '@/components/PaintingCard'
import { upArrow } from '@/assets/images'
import { getAuthorOnCard, getWorkRequest } from '@/server'
import throttle from 'lodash/throttle'
import './index.less'

export function IndexSecondPage() {
  // redux获取token
  const token = useAppSelector((state) => state.login.token)
  // 吸顶图标显隐控制
  const [topDisplay, setTopDisplay] = useState(false)
  // 展示卡片类型：人物/画作
  const showType = useAppSelector((state) => state.indexSecondInfo.showType)
  // 展示信息的所属类型：技法/馆藏...
  const infoKey = useAppSelector((state) => state.indexSecondInfo.infoKey)
  // 展示信息的具体值：工笔/故宫博物院...
  const infoValue = useAppSelector((state) => state.indexSecondInfo.infoValue)
  // 每次加载的画作数量
  const paintingsSize = 21
  // 距离底部多少像素时预加载下一页
  const loadMoreDistance = 600
  // 展示内容的列表
  const [showList, setShowList] = useState<any[]>([])
  // 当前加载到的页码
  const [page, setPage] = useState<number>(1)
  // 总页码数
  const [total, setTotal] = useState<number>(0)
  // 是否正在请求数据，避免滚动时重复触发
  const [loading, setLoading] = useState<boolean>(false)
  // 处理author字符串 authorid_authorname
  function handleAuthorStr(str) {
    const idx = str.indexOf('_')
    return [str.slice(0, idx), str.slice(idx + 1)]
  }

  // 加载数据
  function appendData() {
    if (loading) return
    setLoading(true)

    if (showType === 'painting') {
      // 处理某作者标签下画作集合
      if (infoKey.indexOf('-') !== -1) {
        const keyArr = infoKey.split('-')
        const valueArr = infoValue.split('-')
        const criteria = [
          {
            key: keyArr[0],
            value: valueArr[0]
          },
          {
            key: keyArr[1],
            value: valueArr[1]
          }
        ]
        getWorkRequest(
          {
            criteria,
            pages: {
              page,
              size: paintingsSize
            }
          },
          token
        )
          .then((res) => {
            setShowList((prevShowList) => [...prevShowList, ...res.data.content.list])
            setTotal(res.data.content.total)
            setPage(page + 1)
          })
          .finally(() => setLoading(false))
      } else {
        getWorkRequest(
          {
            criteria: [
              {
                key: infoKey,
                value: infoKey === 'author' ? handleAuthorStr(infoValue)[0] : infoValue
              }
            ],
            pages: {
              page,
              size: paintingsSize
            }
          },
          token
        )
          .then((res) => {
            setShowList((prevShowList) => [...prevShowList, ...res.data.content.list])
            setTotal(res.data.content.total)
            setPage(page + 1)
          })
          .finally(() => setLoading(false))
      }
    } else if (showType === 'author') {
      getAuthorOnCard({ key: infoKey, value: infoValue }, token)
        .then((res) => {
          setShowList(res.data.content)
          setPage(page + 1)
        })
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }

  // 初始加载 page === 1 的数据
  useEffect(() => {
    appendData()
  }, [])

  useEffect(() => {
    // 500ms的节流版appendData
    const throttleAjax = throttle(appendData, 500)
    // 监听屏幕滚动高度，触发加载数据函数以及吸顶图标的显隐
    const handleScroll = function () {
      const scrollElement = document.body
      // 真实内容高度
      const pageHeight = Math.max(scrollElement.scrollHeight, scrollElement.offsetHeight)
      // 视窗高度
      const viewportHeight = scrollElement.clientHeight || window.innerHeight || 0
      // 上面隐藏的高度
      const scrollHeight = scrollElement.scrollTop
      const distanceToBottom = pageHeight - viewportHeight - scrollHeight
      const hasMore = showType === 'painting' && showList.length < total
      console.log(123, distanceToBottom)
      // 通过 真实内容高度 - 视窗高度 - 上面隐藏的高度 < 某阈值，作为加载下一页数据的触发条件
      if (distanceToBottom <= loadMoreDistance && hasMore && !loading) {
        throttleAjax()
      }
      if (scrollHeight > 1500) {
        setTopDisplay(true)
      } else {
        setTopDisplay(false)
      }
    }
    document.body.addEventListener('scroll', handleScroll)
    return () => {
      document.body.removeEventListener('scroll', handleScroll)
      throttleAjax.cancel()
    }
  }, [page, total, showType, infoKey, infoValue, token, showList.length, loading])

  return (
    <>
      <div className='indexSecond-page-container'>
        <div
          className='back-to-top'
          onClick={() => (document.body.scrollTop = 0)}
          style={{ visibility: topDisplay ? 'visible' : 'hidden' }}
        >
          <img src={upArrow}></img>
        </div>
        <div className='header-container'>
          <Header />
        </div>
        <div className='infotitle-container'>
          {(() => {
            if (infoKey === 'author') {
              return handleAuthorStr(infoValue)[1]
            } else if (infoKey.indexOf('-') !== -1) {
              return infoValue.split('-').slice(2).join('-')
            } else {
              return infoValue
            }
          })()}
        </div>
        <div className='infocontent-container'>
          {showList.map((item) =>
            item && showType === 'painting' ? (
              <PaintingCard
                title={item.workname}
                dynasty={infoKey === 'dynasty' ? '' : item.dynasty}
                author={item.authorname}
                museum={infoKey === 'institute' ? '' : item.instname}
                image={item.encoding}
                id={item.workid}
              />
            ) : (
              <AuthorCard name={item.authornamecn} avatar={item.avatarpath} count={item.worknum} />
            )
          )}
        </div>
        <div
          className='end-line-container'
          style={{
            display: showType === 'painting' && showList.length < total ? 'none' : 'flex'
          }}
        >
          <div className='end-line'></div>
          已经到底了
          <div className='end-line'></div>
        </div>
        <Footer />
      </div>
    </>
  )
}
